import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { isExperimentVariantB } from 'chairisher/thirdparty/experiments';
import { getJSON } from 'chairisher/util/fetch';
import { handleAsyncError } from 'chairisher/util/logging';

// @todo CHAIR-19900 Remove after test
/**
 * Reveals the "Bid on LiveAuctioneers" button and its disclaimer for place a bid treatment users when the product has an
 * auction web url, and the save to favorites call to action otherwise. Checking the variant exposes the experiment.
 */
export default function renderPlaceABidExperimentUI(auctionSaveToFavoritesEl) {
    const showSaveToFavorites = () => auctionSaveToFavoritesEl.classList.remove('hidden');
    if (isExperimentVariantB(getAmplitudeExperimentFlagMap().PLACE_A_BID)) {
        const placeABidLink = document.querySelector('.js-place-a-bid-link');
        getJSON(placeABidLink.dataset.auctionWebUrlEndpoint).then(
            (response) => {
                const auctionWebUrl = response?.auction_web_url;
                if (auctionWebUrl) {
                    placeABidLink.href = auctionWebUrl;
                    document.querySelector('.js-place-a-bid').classList.remove('hidden');
                } else {
                    showSaveToFavorites();
                }
            },
            (error) => {
                showSaveToFavorites();
                handleAsyncError(error);
            },
        );
    } else {
        showSaveToFavorites();
    }
}
